export default class Logger {
  static env = process.env.NODE_ENV
  static levels = {
    unknown: 0,
    fatal: 1,
    error: 2,
    warn: 3,
    info: 4,
    debug: 5
  }

  static get logLevel () {
    if (this._logLevel !== undefined) return this._logLevel

    this._logLevel = process.env.NODE_ENV === 'production' ? this.levels.warn : this.levels.debug
    return this._logLevel
  }

  static set logLevel (levelName) {
    return (this._logLevel = this.levels[levelName])
  }

  static add (severityName, ...args) {
    if (this.logLevel >= this.levels[severityName]) {
      console.log(...args)
    }
  }
}

Object.keys(Logger.levels).forEach(name => {
  Logger[name] = (...args) => {
    Logger.add(name, ...args)
  }
})
